import Vue from 'vue';
import Vuex from 'vuex';
import router from './router';
import BankAccountFundResponseModel from '@/models/bankaccounts/BankAccountFundResponseModel';
import BankAccountObligateResponseModel from '@/models/bankaccounts/BankAccountObligateResponseModel';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showSnackbar: false,
    snackbarText: '',
    showTutorial: false,
    showSessionExpiringDialog: false,
    member: {
        authenticated: false,
        givenName: '',
        surname: '',
        jwt: '',
        jwtExpirationTimerId: 0,
        jwtExpirationWarningTimerId: 0,
    },
    selectedBankAccount: null,
    selectedFund: null,
    selectedTransaction: null,
    selectedBankAccountMember: null,
  },
  mutations: {
    mutateJwtExpirationTimerId(state, value) {
      state.member.jwtExpirationTimerId = value;
    },
    mutateJwtExpirationWarningTimerId(state, value) {
      state.member.jwtExpirationWarningTimerId = value;
    },
    mutateMemberAuthenticated(state, value) {
      state.member.authenticated = value;
    },
    mutateMemberGivenName(state, value) {
      state.member.givenName = value;
    },
    mutateMemberSurname(state, value) {
      state.member.surname = value;
    },
    mutateMemberJwt(state, value) {
      state.member.jwt = value;
    },
    mutateShowSnackbar(state, value) {
      state.showSnackbar = value;
    },
    mutateSnackbarText(state, value) {
      state.snackbarText = value;
    },
    mutateShowTutorial(state, value) {
      state.showTutorial = value;
    },
    mutateShowSessionExpiringDialog(state, value) {
      state.showSessionExpiringDialog = value;
    },
    mutateSelectedBankAccount(state, value) {
      state.selectedBankAccount = value;
      state.selectedFund = null;
      state.selectedTransaction = null;
      state.selectedBankAccountMember = null;
    },
    mutateSelectedFund(state, value) {
      state.selectedFund = value;
      state.selectedTransaction = null;
    },
    mutateSelectedTransaction(state, value) {
      state.selectedTransaction = value;
    },
    mutateSelectedBankAccountMember(state, value) {
      state.selectedBankAccountMember = value;
    },
  },
  actions: {
    startJwtExpirationTimer(context, expirationMs: number) {
      // show the warning when we have reached 10% of the expiration
      const warningMs = expirationMs - (expirationMs * .10);
      const warningTimerId: number = setTimeout(() => {
        context.commit('mutateShowSessionExpiringDialog', true);
      }, warningMs);

      context.commit('mutateJwtExpirationWarningTimerId', warningTimerId);

      const expirationTimerId: number = setTimeout(() => {
        context.dispatch('signOut');
        context.commit('mutateShowSessionExpiringDialog', false);
        context.commit('mutateSnackbarText', 'You have been signed out.');
        context.commit('mutateShowSnackbar', true);
        router.push({name: 'signin'});
      }, expirationMs);

      context.commit('mutateJwtExpirationTimerId', expirationTimerId);
    },
    refreshJwtExpirationTimer(context, expirationMs: number) {
      clearTimeout(context.state.member.jwtExpirationTimerId);
      context.dispatch('startJwtExpirationTimer', expirationMs);
    },
    signOut(context) {
      clearTimeout(context.state.member.jwtExpirationTimerId);
      clearTimeout(context.state.member.jwtExpirationWarningTimerId);
      context.commit('mutateJwtExpirationTimerId', 0);
      context.commit('mutateMemberJwt', '');
      context.commit('mutateMemberAuthenticated', false);
      context.commit('mutateMemberGivenName', '');
      context.commit('mutateMemberSurname', '');
      context.commit('mutateSelectedBankAccount', null);
      context.commit('mutateSelectedFund', null);
      context.commit('mutateSelectedTransaction', null);
      context.commit('mutateSelectedBankAccountMember', null);
      context.commit('mutateShowTutorial', false);
    },
    obligateRefresh(context, payload: BankAccountObligateResponseModel) {
      const bank: any = context.state.selectedBankAccount;

      if ( bank != null ) {

        // get deposit fund and update balance
        const depositIdx = bank.funds.findIndex((x: BankAccountFundResponseModel) => x.isDepositFund);
        bank.funds[depositIdx].balance = payload.depositFundBalance;

        // get obligation fund and update balance
        const obligateIdx = bank.funds.findIndex((x: BankAccountFundResponseModel) => x.fundId === payload.obligationFundId);
        bank.funds[obligateIdx].balance = payload.obligationFundBalance;

        context.commit('mutateSelectedBankAccount', bank);
      }
    },
  },
});
